<template>
  <div class="container shadow-lg text-left">
    <div class="w-full">
      <img
        v-lazy="require('@/assets/banners/joinAnAdventure.jpg')"
        alt="Contact Banner"
        class="w-full h-auto object-cover object-bottom max-h-60"
      />
      <h1
        class="text-4xl font-bold -mt-14 mb-10 ml-5 text-white text-left drop-shadow-lg banner-text"
      >
        Join an Adventure
      </h1>
    </div>
    <div class="all-trips-container">
      <h2 class="text-lg font-semibold mb-5">
        Join a group and meet people on one of our set adventure itineraries.
        Our team has been exploring Costa Rica for over two decades so our
        knowledge of one of the most eco-friendly countries in the world is
        extensive. What distinguishes us as a leader in our field is the
        seamlessness of our trips. With safety always a priority, our
        professionalism and attention to detail ensure your adventure is a
        unique experience. Our guides and support team have your enjoyment as
        their goal on every adventure.
      </h2>

      <div
        class="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
      >
        <TripCard
          v-for="trip in joinAnAdventure"
          :key="trip.name"
          :code="trip.code"
          :name="trip.name"
          :map="trip.overview.mapSrc"
          :length="trip.overview.length"
          :price="trip.overview.priceSection.primary.price"
          :sellText="trip.overview.sellText"
        />
      </div>
    </div>
  </div>
</template>

<script>
import tripData from "@/content/trips.js";
import TripCard from "@/components/TripCard.vue";

export default {
  name: "JoinAnAdventureView",
  components: {
    TripCard,
  },
  data() {
    return {
      joinAnAdventure: tripData.joinAnAdventure,
    };
  },
};
</script>

<style scoped>
.all-trips-container {
  max-width: 90%;
  margin: 0 auto;
  padding: 20px;
}
</style>
